import { DictionaryTypeDto } from '@/api/generated';
import { CatalogDictionaryType } from '@/views/catalog/util/catalogDictionaries.util.ts';
import { CatalogSection } from '@/views/catalog/util/catalogSections.util.ts';

export type CatalogResetTranslation = {
  button: string;
  cancel: string;
  clientOffers: string;
  confirm: string;
  confirmationLabel: string;
  dishes: string;
  irreversible: string;
  kept: string;
  keptTitle: string;
  offerElements: string;
  offerGroupDefinitions: string;
  pptxDrafts: string;
  predefinedOffers: string;
  removedTitle: string;
  salesStatistics: string;
  success: string;
  title: string;
};

export type CatalogTranslation = {
  attention: {
    allClear: string;
    dishesExpiring: string;
    dishesMissing: string;
    elementsEnding: string;
    elementsMissing: string;
    pptxFailed: string;
    pptxReady: string;
    setsExpiring: string;
    title: string;
  };
  catalogReset: CatalogResetTranslation;
  dictionaries: Record<CatalogDictionaryType, string> & {
    title: string;
  };
  filters: {
    setsExpiring: string;
  };
  search: {
    noResults: string;
    placeholder: string;
    showAll: string;
  };
  sections: {
    dishes: {
      active: string;
      add: string;
      inactive: string;
    };
    import: {
      empty: string;
      lastImport: string;
      lastImportDetails: string;
      pptx: string;
      xlsx: string;
    };
    offerElements: {
      active: string;
      add: string;
    };
    open: string;
    sets: {
      active: string;
      add: string;
      inactive: string;
    };
  };
  tabs: Record<CatalogSection, string> & {
    title: string;
  };
};

export const catalogTranslation: CatalogTranslation = {
  attention: {
    allClear: 'Cenniki aktualne, nic nie czeka na import.',
    dishesExpiring: 'Cenniki dań kończą się w ciągu {{months}} mies.',
    dishesMissing: 'Dania bez aktualnej ceny',
    elementsEnding: 'Cenniki składowych kończą się w ciągu 60 dni',
    elementsMissing: 'Składowe bez ceny na dziś',
    pptxFailed: 'Szkice z prezentacji, których nie udało się odczytać',
    pptxReady: 'Szkice z prezentacji czekają na wgranie',
    setsExpiring: 'Zestawy wygasają w ciągu {{months}} mies. albo już wygasły',
    title: 'Do zrobienia',
  },
  catalogReset: {
    button: 'Wyczyść katalog',
    cancel: 'Anuluj',
    clientOffers: 'Oferty klientów: {{offers}} (w procesach: {{processes}})',
    confirm: 'Usuń wszystko',
    confirmationLabel: 'Żeby potwierdzić, wpisz',
    dishes: 'Dania razem z cennikami: {{count}}',
    irreversible:
      'Tej operacji nie da się cofnąć. Dane znikną u wszystkich użytkowników — zrób kopię bazy, ' +
      'jeśli możesz ich jeszcze potrzebować.',
    kept:
      'Składowe ofert (sprzęt, dekoracje, obsługa, transport) razem z cennikami, procesy, klienci, ' +
      'kontakty, użytkownicy, słowniki (działy, rodzaje, tagi, typy wydarzeń), ' +
      'szablony wydruku i historia importów. Zadania przypięte do ofert przechodzą do ich procesów, ' +
      'a wpisy ofert w kalendarzu znikają.',
    keptTitle: 'Zostaje',
    offerElements: 'Stare składowe typu „zestaw dań”: {{count}}',
    offerGroupDefinitions: 'Zestawy grup: {{count}}',
    pptxDrafts:
      'Szkice importu z prezentacji tracą powiązania z katalogiem ({{count}}) — przy następnym zapisie ' +
      'dania połączą się ponownie po nazwie z nowo wgranymi.',
    predefinedOffers: 'Oferty predefiniowane (szablony): {{count}}',
    removedTitle: 'Zostanie usunięte',
    salesStatistics: 'Statystyki sprzedaży liczone z ofert zaczną się od zera.',
    success: 'Katalog wyczyszczony: dań {{dishes}}, zestawów {{sets}}, ofert {{offers}}.',
    title: 'Wyczyścić katalog przed nowym importem?',
  },
  dictionaries: {
    [DictionaryTypeDto.DietaryPreference]: 'Preferencje żywieniowe',
    [DictionaryTypeDto.DishDepartment]: 'Działy',
    [DictionaryTypeDto.DishType]: 'Rodzaje dań',
    [DictionaryTypeDto.EventType]: 'Typy wydarzeń',
    [DictionaryTypeDto.Tag]: 'Tagi',
    title: 'Słowniki katalogu',
  },
  filters: {
    setsExpiring: 'Wygasa lub wygasła',
  },
  search: {
    noResults: 'Nic nie znaleziono w katalogu.',
    placeholder: 'Szukaj w katalogu: danie, zestaw albo składowa',
    showAll: 'Pokaż na liście',
  },
  sections: {
    dishes: {
      active: 'Aktywne dania',
      add: 'Dodaj danie',
      inactive: 'Wyłączone: {{count}}',
    },
    import: {
      empty: 'Nie było jeszcze importu z arkusza.',
      lastImport: 'Ostatni import z arkusza',
      lastImportDetails: '{{fileName}} · wgrano {{count}}',
      pptx: 'Z prezentacji',
      xlsx: 'Wgraj arkusz',
    },
    offerElements: {
      active: 'Aktywne składowe',
      add: 'Dodaj składową',
    },
    open: 'Otwórz listę',
    sets: {
      active: 'Aktywne zestawy grup',
      add: 'Dodaj zestaw',
      inactive: 'Wyłączone: {{count}}',
    },
  },
  tabs: {
    [CatalogSection.DISHES]: 'Dania',
    [CatalogSection.HUB]: 'Pulpit',
    [CatalogSection.IMPORT]: 'Import',
    [CatalogSection.OFFER_ELEMENTS]: 'Składowe ofert',
    [CatalogSection.SETS]: 'Zestawy grup',
    title: 'Katalog',
  },
};
